<svg
viewbox="0 0 512 253"
fill="currentColor"
xmlns="http://www.w3.org/2000/svg">
<path
    d="M153.21 172.286H498.286C505.859 172.286 512 166.145 512
    158.571V94.5714C512 86.9977 505.859 80.8572 498.286
    80.8572H153.21V28.2183C153.21 3.78172 123.666 -8.45598 106.386
    8.82287L8.03314 107.176C-2.67885 117.888 -2.67885 135.255 8.03314
    145.966L106.386 244.319C123.665 261.598 153.21 249.36 153.21
    224.923V172.286Z" />
</svg>